import { useEffect, useState } from 'react';
import { MedisanteTargetSystem, Filter } from '../../types';
import {
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  Theme,
} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';

import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/styles';
import ButtonProgress from '../../../../eliot-components/src/ButtonProgress/ButtonProgress';
import { useSendTestMeasurementMutation } from '../../../../store/api-slice';
import { useConfig } from '../../../../eliot-components/src/ConfigProvider/hooks';

interface Props {
  targetSystem: MedisanteTargetSystem | null;
  onClose: () => void;
  isOpen?: boolean;
  setSnack: any;
  onForceClose: () => void;
  isCare: boolean;
  allowModels: string[];
}

const StyledActions = withStyles((theme: Theme) => ({
  root: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}))(DialogActions);

const useStyles = makeStyles((theme: Theme) => ({
  imei: {
    '& > li > pre': {
      margin: '2px 0px',
    },
  },
  warning: {
    padding: '1em',
    backgroundColor: theme.palette.background.default,
    borderRadius: '4px',
    '& p:first-child': {
      marginTop: '0px',
    },
  },
  ts: {
    whiteSpace: 'nowrap',
  },
}));

var filters: Filter[] = [
  {
    key: 'bg800',
    name: 'BG800',
    value: 'BG800 3G',
    label: 'BG800 (IMEI: 900000000000001)',
    active: false,
    disabled: false,
    measurements: ['Glucose'],
  },
  {
    key: 'bp800',
    name: 'BP800',
    value: 'BP800 3G',
    label: 'BP800 (IMEI: 900000000000002)',
    active: false,
    disabled: false,
    measurements: ['BloodPressure', 'Glucose'],
  },
  {
    key: 'bc800',
    name: 'BC800',
    value: 'BC800 3G',
    label: 'BC800 (IMEI: 900000000000003)',
    active: false,
    disabled: false,
    measurements: ['BodyWeightComposition'],
  },
  {
    key: 'pm100',
    name: 'PM100',
    value: 'PM100',
    label: 'PM100 (IMEI: 900000000000004)',
    active: false,
    disabled: false,
    measurements: ['ECG(PDF)', 'ECG'],
  },
  {
    key: 'bt005',
    name: 'BT005',
    value: 'BT005',
    label: 'BT005 (IMEI: 900000000000005)',
    active: false,
    disabled: false,
    measurements: ['BodyWeight'],
  },
  {
    key: 'bt105',
    name: 'BT105',
    value: 'BT105',
    label: 'BT105 (IMEI: 900000000000006)',
    active: false,
    disabled: false,
    measurements: ['BloodPressure'],
  },
  {
    key: 'd40g',
    name: 'D40G',
    value: 'D40G',
    label: 'D40G (IMEI: 900000000000007)',
    active: false,
    disabled: false,
    measurements: ['Glucose', 'BloodPressure'],
  },
  {
    key: 'gtel',
    name: 'GTEL',
    value: 'GTEL',
    label: 'GTEL (IMEI: 900000000000008)',
    active: false,
    disabled: false,
    measurements: ['Ketone', 'Cholesterol', 'URICAcid', 'Glucose'],
  },
  {
    key: 'gw9017',
    name: 'GW9017',
    value: 'GW9017',
    label: 'GW9017 (IMEI: 900000000000009)',
    active: false,
    disabled: false,
    measurements: [
      'BodyTemperature',
      'SpO2',
      'BloodPressure',
      'BodyWeight',
      'Ketone',
      'Cholesterol',
      'URICAcid',
      'Glucose',
    ],
  },
  {
    key: 'bs-2001-g1',
    name: 'BS-2001-G1',
    value: 'BS-2001-G1',
    label: 'BS-2001-G1 (IMEI: 900000000000010)',
    active: false,
    disabled: false,
    measurements: ['BodyWeight'],
  },
  {
    key: 'ls802-gp',
    name: 'LS802-GP',
    value: 'LS802-GP',
    label: 'LS802-GP (IMEI: 900000000000011)',
    active: false,
    disabled: false,
    measurements: ['BloodPressure'],
  },
  {
    key: 'ps300c-rpm',
    name: 'PS300C-RPM',
    value: 'PS300C-RPM',
    label: 'PS300C-RPM (IMEI: 900000000000012)',
    active: false,
    disabled: false,
    measurements: ['BodyWeight'],
  },
  {
    key: 'bm300c-rpm',
    name: 'BM300C-RPM',
    value: 'BM300C-RPM',
    label: 'BM300C-RPM (IMEI: 900000000000013)',
    active: false,
    disabled: false,
    measurements: ['BloodPressure'],
  },
  {
    key: 'bm1000',
    name: 'BM1000',
    value: 'BM1000',
    label: 'BM1000 (IMEI: 900000000000014)',
    active: false,
    disabled: false,
    measurements: ['SpO2'],
  },
  {
    key: 'aoj-90b',
    name: 'AOJ-90B',
    value: 'AOJ-90B',
    label: 'AOJ-90B (IMEI: 900000000000015)',
    active: false,
    disabled: false,
    measurements: ['BloodPressure'],
  },
];

const TriggerTestDialog = (props: Props) => {
  const {
    targetSystem,
    onClose,
    isOpen = true,
    setSnack,
    onForceClose,
    isCare,
    allowModels,
  } = props;
  const config = useConfig();
  const [isLoading, setLoading] = useState(false);
  const classes = useStyles();
  const [filterList, setFilterlist] = useState<Filter[]>([]);
  const [sendTestMeasurements] = useSendTestMeasurementMutation();
  const [selected, setSelected] = useState<Filter>();
  const [measurement, setMeasurement] = useState<string>();

  useEffect(() => {
    if (isOpen) {
      filters.map((f) => {
        f.disabled = false;
        return f;
      });
      if (isCare) {
        filters.map((f) => {
          if (!['BP800', 'BC800', 'BG800'].includes(f.name)) {
            f.disabled = true;
          }
          return f;
        });
      }
      if (allowModels.length > 0) {
        filters = filters.filter((item) => allowModels.includes(item.name));
        setFilterlist(filters);
      } else {
        setFilterlist(filters);
      }
      setLoading(false);
    }
  }, [isOpen, isCare, allowModels]);

  if (targetSystem != null) {
    return (
      <Dialog
        aria-labelledby="dialog-title"
        open={isOpen}
        onClose={() => {
          if (!isLoading) {
            onForceClose();
          }
        }}
      >
        <DialogTitle id="dialog-title">Post Test Measurement</DialogTitle>
        <DialogContent>
          <p>
            Are you sure that you want to send test measurements to{' '}
            <strong className={classes.ts}>{targetSystem.name}</strong> via{' '}
            <strong>HTTP POST</strong> on{' '}
            <i>
              <small>{targetSystem.url}</small>
            </i>
            ?
          </p>
          <div className={classes.warning}>
            <p>
              Please ensure the IMEIs below exist in webhook before sending any
              synthetic data
            </p>
            <FormControl fullWidth margin="normal">
              <InputLabel id="device-model-label">
                Choose device model
              </InputLabel>
              <Select
                labelId="device-model-label"
                value={selected ? selected.key : ''}
                label="Device"
                disabled={filterList.length === 0}
                onChange={(event) => {
                  console.log(event);
                  const id = event.target.value;
                  setSelected(
                    filterList.find((f) => {
                      if (f.key === id) {
                        return f;
                      }
                      return null;
                    })
                  );
                }}
              >
                {filterList.map((item) => {
                  return (
                    <MenuItem
                      value={item.key}
                      key={item.key}
                      disabled={item.disabled}
                    >
                      {item.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
              <InputLabel id="measurement-type-label">
                Choose measurement type
              </InputLabel>
              <Select
                labelId="measurement-type-label"
                value={measurement ? measurement : ''}
                label="Measurement Type"
                disabled={!selected}
                onChange={(event) => {
                  if (event.target.value) {
                    setMeasurement(event.target.value as string);
                  }
                }}
              >
                {selected &&
                  selected.measurements?.map((item) => {
                    return (
                      <MenuItem value={item} key={item}>
                        {item.replace(/([A-Z]+)*([A-Z][a-z])/g, '$1 $2')}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </div>
        </DialogContent>
        <StyledActions>
          <Button disabled={isLoading} onClick={onForceClose}>
            Cancel
          </Button>
          <ButtonProgress
            variant="contained"
            color="primary"
            isLoading={isLoading}
            onClick={() => {
              if (targetSystem) {
                if (!selected) {
                  setSnack('Please select device model');
                  return;
                }
                if (!measurement || measurement.length === 0) {
                  setSnack('Please select measurement type');
                  return;
                }
                setLoading(true);
                sendTestMeasurements({
                  apiBaseURL: config.apiBaseURL,
                  targetSystemId: targetSystem.id,
                  deviceModel: selected.value,
                  measurementType: measurement,
                })
                  .then((resp: any) => {
                    if (!resp.error) {
                      setSnack('Tests run waiting for results');
                      onClose();
                      return;
                    }
                    setSnack(
                      resp.error.message
                        ? resp.error.message
                        : 'Internal server error'
                    );
                    setLoading(false);
                  })
                  .catch((error) => {
                    setSnack(error.toString());
                    onForceClose();
                  });
              }
            }}
          >
            Post
          </ButtonProgress>
        </StyledActions>
      </Dialog>
    );
  }

  return null;
};

export default TriggerTestDialog;
